import { useState } from "react"
import PageLayout from "components/layout/PageLayout"
import Accordion from "components/commons/Accordion";
import ModuleActivityChart from "features/core/company/components/ModuleActivityChart";
import { ProgressBar } from "primereact/progressbar";
import Modal from "components/commons/Modal";
import CountsList from "components/commons/CountsList";
import NewCompanyClosureModal from "../hr/absenceReport/components/NewCompanyCloseModal";
import WorkingWeek from "./WorkingWeek";
import ThisYearHolidays from "./ThisYearHolidays";
import SimpleFileUpload from "components/commons/SimpleFileUpload";
import ExpenseForm from "./ExpenseForm";
import Calendar from "components/commons/Calendar";


const SandBox = () => {

    const [isLoading, setLoading] = useState(null)

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async function refresh() {
        setLoading(true)
        await sleep(1000)
        setLoading(false)
    }

    let content

    content =
        <>
            <Accordion
                items={[
                    {
                        title: "Titolo1",
                        body: "Contenuto1",
                        show: true
                    },
                    {
                        title: "PieChart",
                        body:
                            <ModuleActivityChart
                                data={
                                    [
                                        { name: 'Group A', value: 400, color: "SeaGreen" },
                                        { name: 'Group B', value: 300, color: "Gold" },
                                        { name: 'Group C', value: 150, color: "Firebrick" },
                                    ]
                                }

                            />
                    },
                    {
                        title: "ProgressBar",
                        body:
                            <div>
                                BootStrap
                                <div className="progress" role="progressbar" aria-label="Example with label" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                    <div className="progress-bar" style={{ width: "75%" }}>75%</div>
                                </div>
                                <br />
                                PrimeReact
                                <ProgressBar value={75}></ProgressBar>
                            </div>,
                    },
                    {
                        title: "Modal",
                        body:
                            <div>
                                <Modal
                                    buttonLabel="Try me"
                                    buttonIcon={<i className="fa-solid fa-calendar-check"></i>}
                                    body={<>This is the modal content, defined into property called <b>body</b>.<br />Are you sure you understand?</>}
                                />
                            </div>
                    },
                    {
                        title: "Counts List",
                        body:
                            <div className="col-sm-3">
                                <CountsList data={[
                                    {
                                        "key": "Status White",
                                        "value": 11,
                                        "foregroundClass": "bg-light",
                                        "backgroundClass": "text-dark",
                                    },
                                    {
                                        "key": "Status Green",
                                        "value": 70,
                                        "foregroundClass": "bg-success",
                                        "backgroundClass": "text-white",
                                    }
                                ]} />
                            </div>
                    },
                    {
                        title: "HR",
                        body:
                            <div className="col">
                                <NewCompanyClosureModal />
                                <div className="mt-4">
                                    <WorkingWeek />
                                </div>

                            </div>
                    },
                    {
                        title: "Holidays",
                        body:
                            <div className="col">
                                <ThisYearHolidays />
                            </div>
                    },
                    {
                        title: "File Upload",
                        body:
                            <div className="col">
                                <SimpleFileUpload />
                            </div>
                    },
                    {
                        title: "Expense Form",
                        body:
                            <div className="col">
                                <ExpenseForm />
                            </div>
                    },
                    {
                        title: "Calendar",
                        body:
                            <div className="col">
                                <Calendar />
                            </div>
                    }
                ]}
            />
        </>

    return (
        <PageLayout
            pageTitle={"SandBox"}
            isLoadingContent={isLoading}
            onPageRefresh={refresh}
            bodyContent={content}
        />
    )

}

export default SandBox